<template>
  <div class="container mb-10">
    <!--        <div class="row mt-4 mb-2">
            <div class="col">
                <h1 class="text-center">Choose an opinion to check</h1>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="custom-control custom-radio mr-3">
                <input :id="`commonOpinionRadio`" :name="`opinionRadio`" :value="false"
                    class="custom-control-input" type="radio" required v-model="useOnlyMyOpinion">
                <label class="custom-control-label" :for="`commonOpinionRadio`">Panel opinion</label>
            </div>
            <div class="custom-control custom-radio">
                <input :id="`onlyMyOpinionRadio`" :name="`opinionRadio`" :value="true"
                    class="custom-control-input" type="radio" required v-model="useOnlyMyOpinion">
                <label class="custom-control-label" :for="`onlyMyOpinionRadio`">My opinion</label>
            </div>
        </div>-->

    <div class="row mt-4 mb-2">
      <div class="col">
        <h3 class="">Select indication &#38; stage</h3>
      </div>
    </div>
    <div class="row">
      <div class="row">
        <app-disease-tree-selector
          class="col-xl-6 col-lg-6 col-md-5 col-sm-6 col-12 mb-4"
          :branchId.sync="branchId"
        />
      </div>
    </div>
    <div class="row">
      <div class="custom-control custom-radio mr-3">
        <input
          :id="`commonOpinionRadio`"
          :name="`opinionRadio`"
          :value="false"
          class="custom-control-input"
          type="radio"
          required
          v-model="useOnlyMyOpinion"
        />
        <label class="custom-control-label" :for="`commonOpinionRadio`"
          >Panel opinion</label
        >
      </div>
      <div class="custom-control custom-radio">
        <input
          :id="`onlyMyOpinionRadio`"
          :name="`opinionRadio`"
          :value="true"
          class="custom-control-input"
          type="radio"
          required
          v-model="useOnlyMyOpinion"
        />
        <label class="custom-control-label" :for="`onlyMyOpinionRadio`"
          >My opinion</label
        >
      </div>
    </div>

    <div v-if="branchId">
      <hr />
      <app-questionnaire
        :branchId.sync="branchId"
        :groups.sync="groups"
        :answers.sync="answers"
        :treatmentHistory.sync="treatmentHistory"
      />
      <hr />
      <app-self-check-report-form
        class="pb-5 mx-auto"
        style="max-width: 60%"
        :branchId="branchId"
        :useOnlyMyOpinion="useOnlyMyOpinion"
        :groups="groups"
        :answers="answers"
        :result="result"
      />

      <app-draggable-and-resizable-wrapper>
        <app-questionnaire-result
          :branchId="branchId"
          :useOnlyMyOpinion="useOnlyMyOpinion"
          :groups="groups"
          :answers="answers"
          :treatmentHistory.sync="treatmentHistory"
          :result.sync="result"
        />
      </app-draggable-and-resizable-wrapper>
    </div>
  </div>
</template>

<script lang="ts">
import { Prop, Component, Vue } from "vue-property-decorator";
import AppDiseaseTreeSelector from "@/components/AppDiseaseTreeSelector.vue";
import AppQuestionnaire from "@/components/questionnaire/AppQuestionnaire.vue";
import AppDraggableAndResizableWrapper from "@/components/AppDraggableAndResizableWrapper.vue";
import AppQuestionnaireResult from "@/components/questionnaire/AppQuestionnaireResult.vue";
import AppSelfCheckReportForm from "@/components/expert/AppSelfCheckReportForm.vue";
import { Group } from "@/entities/questionaire/Group";
import { Answer } from "@/entities/questionaire/answers/Answer";
import { QuestionnaireResult } from "@/entities/questionaire/QuestionnaireResult";
import { Treatment } from "@/entities/Treatment";

@Component({
  components: {
    AppDiseaseTreeSelector,
    AppQuestionnaire,
    AppDraggableAndResizableWrapper,
    AppQuestionnaireResult,
    AppSelfCheckReportForm: AppSelfCheckReportForm
  }
})
export default class SelfCheck extends Vue {
  private branchId: number | null = null;
  private useOnlyMyOpinion: boolean = false;
  private groups: Group[] = [];
  private answers: Answer[] = [];
  private treatmentHistory: Treatment[] = [];

  private result: QuestionnaireResult = new QuestionnaireResult([], []);
}
</script>
